<template>
<div>
    <Breadcrumbs main="Finance & Accounts" submain="Finance" title="Bill Edit" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor<span><button class="btn-success ml-3" v-b-modal.modal-prevent-closing>Add New</button></span></label>
                                        <!-- <select class="form-control digits" v-model="bill.vendor" @change="getVendor">
                                            <option v-for="(vendor, index) in vendors" :key="index" :value="vendor.user.id">{{ vendor.user.full_name }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="vendors" :get-option-label="vendorLabel" :reduce="vendor => vendor.user.id" v-model="bill.vendor" @input="getVendor" placeholder="Select a vendor"></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <!-- <select class="form-control digits" v-model="bill.project">
                                            <option v-for="(project, index) in projects" :key="index" :value="project.id">{{ project.title }}</option>
                                        </select> -->
                                        <v-select class="custom-vue-select" :options="projects" label="title" :reduce="project => project.id" v-model="bill.project" placeholder="Select a project"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="bill.email">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <select class="form-control digits" v-model="bill.currency">
                                            <option v-for="(currency, index) in currencies" :key="index">{{ currency }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor Address</label>
                                        <input class="form-control" type="text" placeholder="Enter vendor address" v-model="bill.vendor_address">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="bill.billing_address">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Bill Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="bill.bill_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="bill.due_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="bill.bill_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable v-if="bill.details" style="margin-bottom: 10px;" id="item-table" :tableData="bill.details" @itemsUpdated="updateItems" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="bill.total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="bill.vat_type">
                                                    <option disabled value="">Select Vat Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" v-model="bill.vat" />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Tax -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">
                                           <div class="w-100">
                                                <select class="form-control digits" v-model="bill.tax_type">
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" v-model="bill.tax" />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>

                                            </div>
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Discount -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control" type="number" placeholder="Enter discount (%)" v-model="bill.discount" />
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ bill.currency ? bill.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="bill.subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="bill.in_words" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="bill.remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateType" class="btn btn-success mr-3">Submit</button>
                                        <router-link to="/finance-and-accounts/finance/bill/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Vendor Create -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add New Vendor" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">
            <b-form-group label="First Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="item.first_name" placeholder="Enter first name"></b-form-input>
            </b-form-group>

            <b-form-group label="Last Name" label-for="name-input" invalid-feedback="Item is required">
                <b-form-input id="name-input" v-model="item.last_name" placeholder="Enter last name"></b-form-input>
            </b-form-group>

            <div class="form-group">
                <label>Category</label>
                <multiselect v-model="category" tag-placeholder="Add Category" placeholder="Search or add a category" label="title" :max="vendor_categories.length" track-by="id" :options="vendor_categories" :multiple="true" :taggable="true"></multiselect>
            </div>

            <b-form-group label="Email" label-for="name-input" invalid-feedback="Email is required">
                <b-form-input id="name-input" v-model="item.email" placeholder="Enter email address"></b-form-input>
            </b-form-group>

            <b-form-group label="Phone No" label-for="name-input" invalid-feedback="Phone no is required">
                <b-form-input id="name-input" v-model="item.phone" placeholder="Enter phone number"></b-form-input>
            </b-form-group>

            <b-form-group label="Company" label-for="name-input" invalid-feedback="Company is required">
                <b-form-input id="name-input" v-model="item.company" placeholder="Enter company name"></b-form-input>
            </b-form-group>

            <b-form-group label="Address" label-for="name-input" invalid-feedback="Address is required">
                <b-form-input id="name-input" v-model="item.address" placeholder="Enter address"></b-form-input>
            </b-form-group>
        </form>
    </b-modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import ItemTable from "../items-table/edit-item-table.vue";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            discountAmount: computed(() => {
                if (this.bill.total !== 0) {
                    const discount = this.bill.discount || 0;
                    let total = this.bill.total + discount * (this.bill.total / 100)
                    let gtotal = total - this.bill.total

                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),
            basePrice: computed(() => {
                if (!this.bill ?.total || !this.bill ?.vat_type || !this.bill ?.tax_type) return 0;

                const total = Number(this.bill.total);
                const vat = Number(this.bill.vat || 0);
                const tax = Number(this.bill.tax || 0);

                if (this.bill.vat_type === 'inclusive' && this.bill.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.bill.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.bill.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.bill ?.tax && this.bill ?.tax_type && this.bill ?.total) {
                    const vat = Number(this.bill.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.bill ?.vat && this.bill ?.vat_type && this.bill ?.total) {
                    const vat = Number(this.bill.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),
            bill: {
                vendor: '',
                project: null,
                email: '',
                currency: 'BDT',
                vendor: '',
                bill_attachment: null,
                vendor_address: '',
                billing_address: '',
                bill_date: null,
                due_date: null,
                details: null,
                details_in_depth: [],
                total: computed(() => {
                    let total = 0;
                    if (this.bill.details_in_depth.length >= 1) {
                        this.bill.details_in_depth.map((item) => {
                            total = total + item.rate;
                        });
                    }
                    return total;
                }),
                tax: null,
                vat: null,
                vat_type: '',
                tax_type: '',
                discount: null,
                subtotal: computed(() => {
                    if (!this.bill ?.total || !this.bill ?.vat_type || !this.bill ?.tax_type) return 0;

                    const total = Number(this.bill.total);
                    const discount = Number(this.bill.discount || 0);

                    // Case 1: both VAT and TAX are inclusive → just apply discount to total
                    if (this.bill.vat_type === 'inclusive' && this.bill.tax_type === 'inclusive') {
                        const discounted = total - (total * discount / 100);
                        return Math.round((discounted + Number.EPSILON) * 100) / 100;
                    }

                    // Case 2: Exclusive taxes → add them first
                    let calculated = total;

                    if (this.bill.vat_type === 'exclusive') {
                        calculated += this.vatAmount;
                    }

                    if (this.bill.tax_type === 'exclusive') {
                        calculated += this.taxAmount;
                    }

                    // Apply discount to final calculated total
                    const discounted = calculated - (calculated * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }),
                in_words: '',
                remarks: ''
            },

            category: [],

            item: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                category: [],
                company: '',
                address: '',
                status: true
            },
            vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                vat: '',
                tax: '',
            },

            currencies: ['BDT', 'USD', 'EUR']
        };
    },

    computed: {
        ...mapState({
            detail: state => state.bill.bill_detail,
            items: state => state.item.items,
            projects: state => state.project.project,
            vendors: state => state.vendor.vendor_without_pg,
            vendor_categories: state => state.vendor.vendor_categories
        })
    },

    mounted() {
        this.$store.dispatch("bill/fetchBillDetail", this.$route.params.id)
        this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("project/fetchProject")
        this.$store.dispatch("vendor/fetchVendor_without_pg")
        this.$store.dispatch("vendor/fetchVendorCategory")
    },

    watch: {
        detail(oldValue, newValue) {
            // this.bill.vendor = this.detail.vendor
            // this.bill.project = this.detail.project
            this.bill.email = this.detail.email
            this.bill.currency = this.detail.currency
            this.bill.vendor_address = this.detail.vendor_address
            this.bill.billing_address = this.detail.billing_address
            this.bill.bill_date = this.detail.bill_date
            this.bill.due_date = this.detail.due_date
            this.bill.vendor = this.detail.vendor
            this.bill.details = this.detail.details

            this.bill.details_in_depth = this.bill.details
            this.bill.bill_attachment = this.detail.bill_attachment
            this.bill.total = this.detail.total
            this.bill.vat = this.detail.vat
            this.bill.tax = this.detail.tax

            this.bill.vat_type = this.detail.vat_type
            this.bill.tax_type = this.detail.tax_type
            this.bill.discount = this.detail.discount
            this.bill.subtotal = this.detail.subtotal
            this.bill.in_words = this.detail.in_words
            this.bill.remarks = this.detail.remarks
            this.bill.project = this.detail.project.id
        }
    },

    methods: {
         validateType() {
            this.errors = {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            };

            let valid = true;

            if (!this.bill.vat_type) {
                this.errors.vat_type = 'Vat type is required.';
                valid = false;
            }
            if (!this.bill.tax_type) {
                this.errors.tax_type = 'Tax type is required.';
                valid = false;
            }
            if (!this.bill.vat) {
                this.errors.vat = 'Vat is required.';
                valid = false;
            }
            if (!this.bill.tax) {
                this.errors.tax = 'Tax is required.';
                valid = false;
            }

            if (valid) {
                this.onSubmit();
            }
        },
        vendorLabel(vendor) {
            return vendor ?.user ?.user_name || null
        },

        getVendor() {
            this.$store.dispatch("vendor/fetchVendorByUserId", this.bill.vendor).then(result => {
                this.bill.email = result.data.user.email
                this.bill.vendor_address = result.data.address
                this.bill.billing_address = result.data.address
            })
        },

        uploadFile(e) {
            this.bill.bill_attachment = e.target.files[0];
        },

        updateItems(data) {
            if (data) {
                this.bill.details_in_depth = data;
                this.bill.details = data;
            }
        },

        onSubmit() {
            if (this.bill.bill_date !== null) {
                this.bill.bill_date = moment(String(this.bill.bill_date)).format("YYYY-MM-DD");
            }
            if (this.bill.due_date !== null) {
                this.bill.due_date = moment(String(this.bill.due_date)).format("YYYY-MM-DD");
            }

            this.$store.dispatch("bill/updateBill", {
                id: this.$route.params.id,
                bill: this.bill
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    setTimeout(() => {
                        this.$router.push('/finance-and-accounts/finance/bill/list')
                    }, 2000)

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        resetModal() {
            this.item.first_name = ''
            this.item.last_name = ''
            this.item.email = ''
            this.item.phone = ''
            this.item.company = ''
            this.item.address = ''
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.category.map(item => this.item.category.push(item.id));
            this.$store.dispatch("vendor/addVendor", {
                item: this.item
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });

                    this.bill.vendor = response.data.user
                    this.bill.email = response.data.email
                    this.bill.vendor_address = response.data.address
                    this.bill.billing_address = response.data.address

                    this.item.first_name = ''
                    this.item.last_name = ''
                    this.item.email = ''
                    this.item.phone = ''
                    this.item.company = ''
                    this.item.address = ''

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        }
    }
};
</script>
